import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './VillageCardPage.css';
import { IVillageCardPageStoreProps } from './container';
import { EExtraVillages } from '../../constants/village';
import { CarouselContainer } from '../../containers/Carousel';
import { FatFeatureListContainer } from '../../containers/FatFeatureList';
import { FatInfrastructureListContainer } from '../../containers/FatInfrastructureList';
import { FeedbackContainer } from '../../containers/Feedback';
import { GenplanContainer } from '../../containers/GenplanContainer';
import { isClient } from '../../utils/helpers';
import { isStickySupported } from '../../utils/is_sticky_supported';
import { TgbAsideBannerContainer, TgbBottomBannerContainer } from '../AdfoxBanner';
import { ExtraVillagesContainer } from '../ExtraVillages';
import { MagazineContainer } from '../Magazine/container';
import { PromosContainer } from '../Promos/container';
import { AboutContainer } from '../about/container';
import { AboutBuilderMainContainer } from '../about_builder_main/container';
import { BreadcrumbsContainer } from '../breadcrumbs/container';
import { FeaturesContainer } from '../features';
import { InfrastructureContainer } from '../infrastructure/container';
import { MainContactsContainer } from '../main_contacts/container';
import { MapBlockContainer } from '../map_block/container';
import { NeighbourhoodContainer } from '../neighborhood/container';
import { SidebarContainer } from '../sidebar/container';
import { VillageInfoContainer } from '../village_info/container';
import { VillageObjectsContainer } from '../village_objects/container';

let top: number;
let isSticky: boolean;
export class VillageCardPage extends React.Component<IVillageCardPageStoreProps> {
  public componentDidMount() {
    if (isClient() && !isStickySupported()) {
      (this.cardInner.current as HTMLDivElement).style.position = 'relative';

      const style = window.getComputedStyle(this.cardInner.current as Element);

      top = parseInt(style.top || '0', 10);
      (this.wrapper.current as HTMLDivElement).style.position = 'relative';
      (this.cardInner.current as HTMLDivElement).style.top = String(0);
      (this.placeholder.current as HTMLDivElement).style.overflow = 'hidden';

      this.update();

      window.addEventListener('scroll', this.update);
      window.addEventListener('resize', this.update);
    }
  }

  private cardInner: React.RefObject<HTMLDivElement> = React.createRef();

  private parentContainer: React.RefObject<HTMLDivElement> = React.createRef();

  private wrapper: React.RefObject<HTMLDivElement> = React.createRef();

  private placeholder: React.RefObject<HTMLDivElement> = React.createRef();

  public render() {
    const { isMenuVisible, isFat, isCroppedCard, isPromotionsVillageData } = this.props;
    const isStickyByClass = isClient() && isStickySupported();

    return (
      <>
        {this.renderFatHeader()}
        <div className={styles['village_card']}>
          {!isFat && (
            <div className={styles['village_card-top']}>
              <BreadcrumbsContainer />
            </div>
          )}
          <div className={styles['village_card-main']}>
            <VillageInfoContainer />
            <FatFeatureListContainer />
            <VillageObjectsContainer />
            {isPromotionsVillageData && <PromosContainer />}
            <MagazineContainer />
            <GenplanContainer />
            {!isFat && <FeaturesContainer />}
            <MainContactsContainer />
            <MapBlockContainer />
            <FatInfrastructureListContainer />
            <NeighbourhoodContainer />
            {!isCroppedCard && <InfrastructureContainer />}
            <AboutContainer />
            <AboutBuilderMainContainer />
          </div>
          <div ref={this.parentContainer} className={styles['village_card-aside']}>
            <div
              ref={this.cardInner}
              {...mergeStyles(
                styles['village_card-aside-inner'],
                isStickyByClass && styles['village_card-aside-inner-transition'],
                isMenuVisible && styles['village_card-aside-inner--with-menu'],
              )}
            >
              <div className={styles['village_card-aside-wrapper']} ref={this.wrapper}>
                <SidebarContainer />
                <FeedbackContainer />
                <TgbAsideBannerContainer />
              </div>
              <div ref={this.placeholder} />
            </div>
          </div>
          <div className={styles['village_card-footer']}>
            <ExtraVillagesContainer type={EExtraVillages.Similar} />
            <ExtraVillagesContainer type={EExtraVillages.Nearby} />
          </div>
          <div className={styles['bottom_banner']}>
            <TgbBottomBannerContainer />
          </div>
        </div>
      </>
    );
  }

  private renderFatHeader = () => {
    if (!this.props.isFat) {
      return null;
    }

    return (
      <>
        <div className={styles['breadcrumbs_wrapper']}>
          <BreadcrumbsContainer />
        </div>
        <CarouselContainer />
      </>
    );
  };

  public componentWillUnmount() {
    if (isClient() && !isStickySupported()) {
      window.removeEventListener('scroll', this.update);
      window.removeEventListener('resize', this.update);
    }
  }

  private update = () => {
    if (!isClient()) {
      return;
    }
    const rect = (this.cardInner.current as Element).getBoundingClientRect();
    if (rect.top < top) {
      (this.placeholder.current as HTMLDivElement).style.height = `${rect.height}px`;
      (this.placeholder.current as HTMLDivElement).style.width = `${rect.width}px`;
      const parentRect = (this.parentContainer.current as Element).getBoundingClientRect();
      (this.wrapper.current as HTMLDivElement).style.top = `${Math.min(
        parentRect.top + parentRect.height - rect.height - 8,
        this.props.isMenuVisible ? 60 : 8,
      )}px`;
      (this.wrapper.current as HTMLDivElement).style.width = `${rect.width}px`;

      this.stick();
    } else {
      this.unstick();
    }
  };

  private stick = () => {
    if (isSticky) {
      return;
    }

    (this.wrapper.current as HTMLDivElement).style.position = 'fixed';
    isSticky = true;
  };

  private unstick = () => {
    if (!isSticky) {
      return;
    }
    (this.wrapper.current as HTMLDivElement).style.position = 'relative';
    (this.wrapper.current as HTMLDivElement).style.width = '';
    (this.wrapper.current as HTMLDivElement).style.top = '';
    (this.placeholder.current as HTMLDivElement).style.height = '';
    (this.placeholder.current as HTMLDivElement).style.width = '';

    isSticky = false;
  };
}
